module.exports = __webpack_public_path__ + "static/media/preview-1.fe1e71c8.jpg";